export enum MedicationsSelectActions {
    all = 'all',
    current = 'current',
    none = 'none',
}
